import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from './Logo';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg py-2' : 'bg-white py-4'}`}>
      <div className="container mx-auto px-4 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <Logo 
            width="150" 
            className="h-12 md:h-16 transition-all duration-300"
          />
        </Link>
        
        {/* Mobile menu button */}
        <button 
          className="md:hidden text-black focus:outline-none hover:text-yellow-600 transition-colors duration-300"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
        
        {/* Desktop Navigation */}
        <div className="hidden md:flex space-x-8">
          <Link 
            to="/menu" 
            className={`nav-link-white ${location.pathname === '/menu' ? 'active' : ''}`}
          >
            Menu
          </Link>
          <Link 
            to="/drinks" 
            className={`nav-link-white ${location.pathname === '/drinks' ? 'active' : ''}`}
          >
            Drinks
          </Link>
          <Link 
            to="/our-story" 
            className={`nav-link-white ${location.pathname === '/our-story' ? 'active' : ''}`}
          >
            Our Story
          </Link>
          {/* <Link
            to="/specials"
            className={`nav-link-white ${location.pathname === '/specials' ? 'active' : ''}`}
          >
            Specials
          </Link>
          <Link
            to="/events"
            className={`nav-link-white ${location.pathname === '/events' ? 'active' : ''}`}
          >
            Events
          </Link>
          <Link
            to="/gift-cards"
            className={`nav-link-white ${location.pathname === '/gift-cards' ? 'active' : ''}`}
          >
            Gift Cards
          </Link> */}
          <a
            href="tel:+17047999771"
            className="bg-yellow-500 text-black px-4 py-2 rounded-md font-medium hover:bg-yellow-600 transition-colors duration-300"
          >
            Call to Order: (704) 799-9771
          </a>
        </div>
        
        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg">
            <div className="flex flex-col p-4 space-y-4">
              <Link 
                to="/menu" 
                className={`nav-link-white block py-2 ${location.pathname === '/menu' ? 'active' : ''}`}
                onClick={toggleMenu}
              >
                Menu
              </Link>
              <Link 
                to="/drinks" 
                className={`nav-link-white block py-2 ${location.pathname === '/drinks' ? 'active' : ''}`}
                onClick={toggleMenu}
              >
                Drinks
              </Link>
              <Link 
                to="/our-story" 
                className={`nav-link-white block py-2 ${location.pathname === '/our-story' ? 'active' : ''}`}
                onClick={toggleMenu}
              >
                Our Story
              </Link>
              {/* <Link
                to="/specials"
                className={`nav-link-white block py-2 ${location.pathname === '/specials' ? 'active' : ''}`}
                onClick={toggleMenu}
              >
                Specials
              </Link>
              <Link
                to="/events"
                className={`nav-link-white block py-2 ${location.pathname === '/events' ? 'active' : ''}`}
                onClick={toggleMenu}
              >
                Events
              </Link>
              <Link
                to="/gift-cards"
                className={`nav-link-white block py-2 ${location.pathname === '/gift-cards' ? 'active' : ''}`}
                onClick={toggleMenu}
              >
                Gift Cards
              </Link> */}
              <a
                href="tel:+17047999771"
                className="bg-yellow-500 text-black px-4 py-2 rounded-md font-medium hover:bg-yellow-600 transition-colors duration-300 text-center mt-2"
                onClick={toggleMenu}
              >
                Call to Order: (704) 799-9771
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
